import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const gcsContract = c.router(
  {
    generateSignedUrlForUploadPublicFiles: {
      method: 'POST',
      path: '/presigned-public',
      responses: {
        201: z.object({
          url: z.string(),
          gcsFilePath: z.string(),
        }),
      },
      body: z.object({
        userUploadId: z.string(),
        fileExt: z.string(),
        // Explicit per-request tenant (membership-verified server-side).
        // Optional for old bundles, which fall back to the session claim —
        // make it required once they age out. [ENG-5545]
        tenantId: z.string().optional(),
      }),
      summary: 'Requests a presigned GCS Url for uploading a public file',
    },
  },
  {
    pathPrefix: '/gcs',
  },
);
